import { render, staticRenderFns } from "./WsDateRange.vue?vue&type=template&id=63fa72d0"
import script from "./WsDateRange.vue?vue&type=script&lang=js"
export * from "./WsDateRange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports